import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Navbar from "../Navbar";
import Dropdown from "./Dropdown";

export default function StockFunds({ user }) {
    const navigate = useNavigate();

    const goNext = () => {
        navigate("/BondFunds");
    };

    const goPrev = () => {
        navigate("/MutualFunds");
    };

    return (
        <div className="h-screen overflow-hidden">
            <Navbar user={user} />
            <Dropdown />
            <div className="w-full flex flex-col justify-center items-center overflow-hidden">
                <div className="text-[#000000] text-5xl m-4 font-bold">
                    Stock Funds
                </div>
                <span className="w-full h-0.5 bg-blueInFigma"></span>
                <div className="text-[#000000] text-3xl mt-3">
                    Stock funds invest in stocks or equity.  There are various types of stock funds, 
                </div>
                <div className="text-[#000000] text-3xl">
                    and they are categorized based on both the size of the company, their market caps 
                </div>
                <div className="text-[#000000] text-3xl">
                    (value of a company’s market), and the growth prospects of the invested stocks.  
                </div>
                <div className="text-[#000000] text-3xl">
                    They can be divided into 2 categories:  value funds and growth funds.  A value 
                </div>
                <div className="text-[#000000] text-3xl">
                    fund invests in high-quality, low-growth companies that are out of favor in the 
                </div>
                <div className="text-[#000000] text-3xl">
                    market, while a growth fund invests in companies with high growth.
                </div>
            </div>
            <button className="bg-[#73C4FC] text-[#FFFFFF] p-4 absolute bottom-[10%] right-[17.5%] text-3xl rounded-2xl"
                onClick={goNext}
            >
                Next
            </button>
            <button className="bg-blueInFigma text-[#FFFFFF] p-4 absolute bottom-[10%] left-[17.5%] text-3xl rounded-2xl"
                onClick={goPrev}
            >
                Prev
            </button>
        </div>
    );
}